import { hasProgrammingTeachingLoad } from 'app/services/featureFlag.service';
import { systemSettings } from 'app/store/index';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useSelector } from 'react-redux';

function useFeatureFlag(flag) {
  const system = useSelector((state) => systemSettings.selectors.getSetting(state));
  const organization = useSelector((state) => systemSettings.selectors.getOrganization(state));

  const flagConditions = {
    editorialRestrictedAccessAdmin: () => !!system?.editorial_access_enabled,
    enableBackgroundGradient: () => !!system?.enable_program_look_advanced,
    enableLessonPlannerAdvanced: () => !!system?.enable_lesson_planner_avanced,
    enableMappingPdfIa: () => !!system?.enable_mapping_pdf_ia,
    enableTutorAiByLicense: () => !!system?.enable_tutor_ai_by_license,
    enableTutorAiGlobal: () => !!system?.is_tangerine_ai,
    enablePopups: () => !!system?.enable_program_look_advanced,
    enablePowerLesson: () => !!system?.enable_power_lesson,
    enableRowColumnLayout: () => !!system?.enable_program_look_advanced,
    enableTextTooltips: () => !!system?.enable_program_look_advanced,
    isSinglePost: () => !!system?.enable_mint_single_post,
    showEvaluationOptions: () => !!system?.enable_evaluation_model,
    showLibrary: () => !!system?.enable_library,
    showMintLesson: () => !!system?.enable_mint_lesson,
    showLicenseMonoProgram: () => !!system?.has_license_mono_program,
    showMintPageLessonItemDual: () => !!system?.show_mint_page_lesson_item_dual,
    showPowerLesson: () => !!system?.enable_power_lesson,
    showProgramArticles: () => !!system?.third_party_integrations,
    showProgramLookAdvanced: () => !!system?.enable_program_look_advanced,
    showProgramResources: () => !!system?.show_program_resources,
    showProgramTraining: () => !!system?.enable_training,
    showProgramming: () => !!system?.enable_programing,
    showProgrammingAdvanced: () => !!system?.enable_advanced_programming,
    showProgrammingTeachingLoad: () => hasProgrammingTeachingLoad(organization),
    showStructureLevels: () => !!system?.enable_structure_levels,
    showProgramType: () => !!system?.enable_program_type,
    mintHideOptionAudiosPost: () => !!system?.mint_hide_option_audios_post,
    hasLicenseMonoProgram: () => !!system?.has_license_mono_program,
    mintHideOptionPdfPages: () => !!system?.mint_hide_option_pdf_pages,
    showExportXapi: () => !!system?.enable_export_xapi,
    showActivitiesBatchManagement: () => !!system?.enable_activity_batch,
    // mintShowAssistantEditor
    // showAudiosMint
    // showLemonadeFeedbackGenerator
    // showMessagesGlobalBackoffice
    thirdPartyIntegrations: () => !!system?.third_party_integrations,
    // Default flag
    default: (flagName) => useFeatureFlagEnabled(flagName),
  };

  const getFlagValue = flagConditions[flag] || flagConditions.default;

  return { value: getFlagValue(flag) };
}

export default useFeatureFlag;
